export default __webpack_public_path__ + "static/media/icon.66327830.png";